import React from 'react';
import {InputAdornment, IconButton, FormHelperText, FormControl, TextField} from '@mui/material';
import {VisibilityOff, Visibility} from '@mui/icons-material';
import {useStyles} from './style';

export default function FormControlDeContrasena(props) {
    const classes = useStyles(props);

    const [values, setValues] = React.useState({
        password: '',
        showPassword: false,
      });


    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
      };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <FormControl className={classes.formControl} >
            <TextField
                key={props.name}
                label={props.label}
                id={props.name}
                name={props.name}
                value={props.value}
                type={values.showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                onChange={props.handleChange}
                keypress={props.keyPress}
                error={props.isError}
                aria-describedby="component-error-text"
                InputProps={{
                  endAdornment: (
                          <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {values.showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                }}
            />
            {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
        </FormControl>
    )
}